export default __webpack_public_path__ + "static/elevator_b.527bcee349f77e1b0cc4ae880801e235.svg";